import LinkedCalendarEntry from 'owa-service/lib/contract/LinkedCalendarEntry';
import Calendar from '../store/schema/Calendar';
import { getCalendarEntry } from '../selectors/calendarsCacheSelectors';
import { isLinkedCalendar } from 'owa-calendar-properties';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Checks if a given calendar belongs to the specified mailbox
 * @param calendar calendar to check
 * @param {string} emailAddress the mailbox owner of the calendars
 */
export default function isCalendarInMailbox(calendar: Calendar, emailAddress: string): boolean {
    let calendarEntry: any = getCalendarEntry(calendar);

    if (isLinkedCalendar(calendarEntry)) {
        let linkedCalendarEntry = calendarEntry as LinkedCalendarEntry;
        return (
            !linkedCalendarEntry.IsOwnerEmailAddressInvalid &&
            linkedCalendarEntry.OwnerEmailAddress == emailAddress
        );
    }

    if (calendar.id && calendar.id.mailboxInfo) {
        return emailAddress.indexOf(calendar.id.mailboxInfo.primarySmtpAddress) >= 0;
    } else {
        return getUserConfiguration().SessionSettings.UserEmailAddress == emailAddress;
    }
}
